import React from "react";
import { Form, Icon, Input, Button, message } from "antd";
import { FormComponentProps } from "antd/es/form";

import MainStyle from "../../main/main.module.scss";
import usePromiseCallback from "Utils/usePromiseCallback";

import Style from "./changepwd.module.scss";
import { changePwd } from "API/auth";
import { useHeaderProps } from "../../../components/Layouts/SubLayout/useHeaderProps";

interface IPageChangePwdProps extends FormComponentProps {}

const PageChangePwd = (props: IPageChangePwdProps) => {
    const { getFieldDecorator } = props.form;

    useHeaderProps({ title: "修改密码" });

    const handleSubmit = usePromiseCallback(
        async (e: React.FormEvent<HTMLFormElement>) => {
            e.preventDefault();

            return props.form.validateFields((err, values) => {
                if (err) return;
                return changePwd(values.password, values.newpassword)
                    .then(res =>
                        message.success("修改成功，请重新登录！", 1, () => {
                            window.location.href = "/login";
                        })
                    )
                    .catch(err => message.error(err.response.data.message));
            });
        }
    );

    const compareToFirstPassword = (rule: any, value: any, callback: any) => {
        const { form } = props;
        if (value && value !== form.getFieldValue("newpassword")) {
            callback("两次密码输入不一致！");
        } else {
            callback();
        }
    };

    return (
        <div className={MainStyle.main}>
            <div className={Style.form}>
                <h1>修改密码</h1>
                <Form className="login-form" onSubmit={handleSubmit}>
                    <Form.Item>
                        {getFieldDecorator("password", {
                            rules: [
                                { required: true, message: "请输入原密码!" }
                            ]
                        })(
                            <Input.Password
                                size="large"
                                prefix={
                                    <Icon
                                        type="lock"
                                        style={{ color: "rgba(0,0,0,.25)" }}
                                    />
                                }
                                placeholder="请输入原密码"
                            />
                        )}
                    </Form.Item>
                    <Form.Item>
                        {getFieldDecorator("newpassword", {
                            rules: [
                                { required: true, message: "请输入新密码!" }
                            ]
                        })(
                            <Input.Password
                                size="large"
                                prefix={
                                    <Icon
                                        type="lock"
                                        style={{ color: "rgba(0,0,0,.25)" }}
                                    />
                                }
                                placeholder="请输入新密码"
                            />
                        )}
                    </Form.Item>
                    <Form.Item>
                        {getFieldDecorator("renewpassword", {
                            rules: [
                                {
                                    required: true,
                                    message: "请确认新密码!"
                                },
                                { validator: compareToFirstPassword }
                            ]
                        })(
                            <Input.Password
                                size="large"
                                prefix={
                                    <Icon
                                        type="lock"
                                        style={{ color: "rgba(0,0,0,.25)" }}
                                    />
                                }
                                placeholder="请再次输入新密码"
                            />
                        )}
                    </Form.Item>
                    <Form.Item>
                        <Button
                            type="primary"
                            size="large"
                            htmlType="submit"
                            block
                            className={Style.loginBtn}>
                            修改
                        </Button>
                    </Form.Item>
                </Form>
            </div>
        </div>
    );
};
export default Form.create<IPageChangePwdProps>({ name: "normal_login" })(
    PageChangePwd
);
